import axios from "axios";
import { Constants } from "../utils/Constants";

export function getDataTable(events) {
    return axios.post(`${Constants.baseUrl}/user/list`, events);
}

export function create(form) {
    return axios.post(`${Constants.baseUrl}/user`, form);
}

export function get(id) {
    return axios.get(`${Constants.baseUrl}/user/${id}`);
}

export function update(form, id) {
    return axios.patch(`${Constants.baseUrl}/user/${id}`, form);
}

export function destroy(id) {
    return axios.delete(`${Constants.baseUrl}/user/${id}`);
}

export function getSimpleList() {
    return axios.get(`${Constants.baseUrl}/user/list-all`);
}